<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  id: {
    required: true,
    type: String,
  },
});
</script>

<template>
  <div :id="props.id" class="c-listbox" role="listbox">
    <slot />
  </div>
</template>

<style lang="scss">
@import '@/ui/styles/functions/functions';
@import '@/ui/styles/settings/colors';
@import '@/ui/styles/settings/units';

.c-listbox {
  position: absolute;
  top: calc(100% - #{$border-radius-small});
  left: 0;
  z-index: 2003; // sit above reciteme
  margin: 0;
  padding: 0;
  width: 100%;
  max-height: 70vh;
  overflow-y: auto;
  background-color: $white;
  box-shadow: 0 rem(4px) rem(10px) rgba($black, 0.15);
}
</style>
